export default __webpack_public_path__ + "static/media/rightMasjit.293b1559.png";